import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { INotificationDelegate } from '../../../global/helpers/notification_delegate';
import { CourseSlot } from './../../../global/builders/ap_generic_slot_builder';
import { RouterHelper } from './../../../global/helpers/router_helper';
import { DEEMPHASIZE_DROP_AREA, EMPHASIZE_DROP_AREA } from './../../constants/event_names';

class CourseSlotComponent {
  private genericSlot: CourseSlot;
  private isEditable: boolean | string;
  private boldTextEnabled: boolean;
  constructor(private ngComponentCommunicatorService: CommunicatorService, private routerHelper: RouterHelper) {}

  $onChanges() {
    this.boldTextEnabled = _4.isBoolean(this.boldTextEnabled) ? this.boldTextEnabled : this.boldTextEnabled === 'true';
    this.isEditable = _4.isBoolean(this.isEditable) ? this.isEditable : this.isEditable === 'true';
  }

  emphasizeDropArea() {
    this.ngComponentCommunicatorService.publish(EMPHASIZE_DROP_AREA);
  }
  deEmphasizeDropArea() {
    this.ngComponentCommunicatorService.publish(DEEMPHASIZE_DROP_AREA);
  }

  showCourseDetails() {
    return this.routerHelper.findStateAndGo('.course_details', {
      courseDetails: {
        courseNk: this.genericSlot.course.nk,
        termId: this.genericSlot.termId,
        title: this.genericSlot.course._title,
        programSlotId: _4.get(this.genericSlot, 'programSlot.id', null),
        slotType: !_4.isEmpty(this.genericSlot.programSlot)
          ? _4.get(this.genericSlot, 'programSlot.slot_type', null)
          : 'COURSE'
      }
    });
  }
}

angular.module('capability-ng-academic-planner').component('courseSlotComponent', {
  templateUrl: 'capability-ng-academic-planner/src/plan/components/course_slot_component/course_slot_component.html',
  controller: CourseSlotComponent,
  transclude: {
    actions: '?actionsLeftSide'
  },
  bindings: {
    genericSlot: '<',
    disableDrag: '<',
    isEditable: '<',
    boldTextEnabled: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/course_slot_component/course_slot_component.ts